import ConfirmationPage from 'app/Pages/Reservation/ConfirmationPage'
import React from 'react'

const Section = () => {
	return <ConfirmationPage />
}

export default Section
